module.exports = __webpack_public_path__ + "static/img/10.5064001.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/10.jpg
// module id = wnzR
// module chunks = 1